import { MMOAssetManager } from "@game/config";
import { AssetNames } from "@utils/types";

/**
 * Gets animation asset
 */
export function getAnimation(animation: AssetNames) {
  return {
    clip: MMOAssetManager.getObject3D(animation, {
      cloneSkeleton: true,
    }).animations[0],
  };
}
